<template>
  <div id="inner_sidebar">
    <div v-if="$store.state.module.nm == '1'">
      <a :href="'https://sportips.fr/inscription/' + $store.state.module.base" target="_blank">
        <b-button class="with_icon"><b-icon icon="pencil" aria-hidden="true"></b-icon> {{ $t("tab_courses.inscription") }}</b-button>
      </a>
      <a :href="'https://sportips.fr/inscription/' + $store.state.module.base + '/fiche'" target="_blank"
        ><b-button class="with_icon"><b-icon icon="person" aria-hidden="true"></b-icon>{{ $t("tab_courses.acces_inscription") }}</b-button></a
      >
    </div>
    <div v-else>
      <a :href="'https://sportips.fr/' + $store.state.module.base" target="_blank" v-if="$store.state.module.inscription_ouverte && $store.state.module.base != 'CVD22'">
        <b-button class="with_icon"><b-icon icon="pencil" aria-hidden="true"></b-icon> {{ $t("tab_courses.inscription") }}</b-button>
      </a>
      <b-button disabled v-else-if="$store.state.module.base != 'CVD22'" class="with_icon"> <b-icon icon="pencil" aria-hidden="true"></b-icon>{{ $t("tab_courses.inscriptions_closes") }} </b-button>
      <a :href="'https://sportips.fr/' + $store.state.module.base + '/fiche.php'" target="_blank" v-if="$store.state.module.acces_fiche && $store.state.module.base != 'CVD22'"
        ><b-button class="with_icon"><b-icon icon="person" aria-hidden="true"></b-icon>{{ $t("tab_courses.acces_inscription") }}</b-button></a
      >
      <b-button v-else-if="$store.state.module.base != 'CVD22'" disabled class="with_icon"><b-icon icon="person" aria-hidden="true"></b-icon> {{ $t("tab_courses.acces_inscription") }}</b-button>
    </div>

    <router-link to="parcours"
      ><b-button class="with_icon"><b-icon icon="signpost-split" aria-hidden="true"></b-icon> {{ $t("les_parcours") }}</b-button></router-link
    >
    <a v-if="$store.state.module.lien_reglement_interne" :href="'https://sportips.fr/' + $store.state.module.base + '/reglement/' + $store.state.module.lien_reglement_interne" target="_blank"
      ><b-button class="with_icon"><b-icon icon="card-checklist" aria-hidden="true"></b-icon> {{ $t("tab_courses.reglement") }}</b-button></a
    >
    <a v-if="$store.state.module.site" :href="$store.state.module.site" target="_blank"
      ><b-button class="with_icon"><b-icon icon="link" aria-hidden="true"></b-icon> {{ $t("tab_courses.site") }}</b-button></a
    >
    <a v-for="(extra, index) in $store.state.admin.extra_links" :key="index" :href="extra.url" target="_blank"
      ><b-button class="with_icon"><v-icon style="min-width: 17px" :name="extra.icon"></v-icon> {{ extra.text }}</b-button></a
    >
  </div>
</template>

<script>
export default {};
</script>

<style lang="sass" scoped>
</style>